import { react2angular } from 'react2angular';
import { ConsistEventHistoryTable } from './ConsistEventHistoryTable';

angular
  .module('webtip.module')
  .component('consistEventHistoryTable', react2angular(ConsistEventHistoryTable, [
    'eventHistory',
    'consistList',
    'consistEvents',
    'consistEventsLoading',
    'selectedEnvData',
    'loadBusy',
    'hasMore',
    'isActive',
    'consistSortType',
    'consistReversed',
    'onLoadMore',
    'onExpandConsist',
    'onSortConsist',
  ], ['formatTimestampFilter']));
